import { useLocation } from 'react-router-dom';
import { useState, useEffect, useRef, type ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
}

const PageTransition = ({ children }: PageTransitionProps) => {
  const location = useLocation();
  const [displayChildren, setDisplayChildren] = useState(children);
  const [visible, setVisible] = useState(true);
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname === prevPathRef.current) return;
    prevPathRef.current = location.pathname;

    // 先淡出
    setVisible(false);

    const timer = setTimeout(() => {
      setDisplayChildren(children);
      setVisible(true);
    }, 120);

    return () => clearTimeout(timer);
  }, [location.pathname, children]);

  // 同步更新 children（同路径内容变化时直接更新）
  useEffect(() => {
    if (visible) {
      setDisplayChildren(children);
    }
  }, [children, visible]);

  return (
    <div
      style={{
        opacity: visible ? 1 : 0,
        transition: visible
          ? 'opacity 0.22s ease-out'
          : 'opacity 0.1s ease-in',
      }}
    >
      {displayChildren}
    </div>
  );
};

export default PageTransition;
